import React from "react";
import Navbar from "../components/Navbar";
import Real1 from "../assets/img/Réalisation1.png";
import Real2 from "../assets/img/Réalisation2.png";
import PromesseImg from "../assets/img/HomeP.png";
import CarouselReal from "../components/CarouselReal";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";
import Carousel1 from "../components/Carousel1";

const Realisations = () => {
  return (
    <div>
      <Helmet>
        <title>
          Mes réalisations – Peinture intérieure et extérieure à Vannes
        </title>
        <meta
          name="description"
          content="Découvrez les chantiers réalisés par LM Couleurs : peinture de murs, plafonds, boiseries, ravalement de façades, finitions soignées à Vannes et alentours."
        />
        <link rel="canonical" href="https://lmcouleurs.fr" />
        <meta
          property="og:title"
          content="Nos réalisations – LM Couleurs à Vannes"
        />
        <meta
          property="og:description"
          content="Exemples de chantiers réalisés à Vannes : peinture murs, enduits décoratifs, boiseries..."
        />
        <meta property="og:url" content="https://lmcouleurs.fr/realisations" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://lmcouleurs.fr/images/og-realisations.jpg"
        />
      </Helmet>

      <Navbar />
      <div className="realisations">
        <h1>Mes Réalisations</h1>
        <p>
          Chaque projet mérite toute mon attention. En tant qu'artisan peintre
          indépendant, je m'engage à vous offrir un accompagnement personnalisé
          à chaque étape de votre projet.
        </p>
        {/* <div className="realisations-images-container">
          <div className="realisations-images">
            <div className="real1">
              <div className="real1img">
                <p>Top réalisation</p>
              </div>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
                dolorum a ad eius quibusdam maiores, perferendis illo quos hic
                doloremque dicta tempore adipisci nam cumque molestiae eaque
                reprehenderit? Iure delectus perspiciatis consequatur animi
                adipisci.
              </p>
            </div>
            <div className="real2">
              <div className="real2img">
                <p>Top réalisation</p>
              </div>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
                dolorum a ad eius quibusdam maiores, perferendis illo quos hic
                doloremque dicta tempore adipisci nam cumque molestiae eaque
                reprehenderit? Iure delectus perspiciatis consequatur animi
                adipisci.
              </p>
            </div>
          </div> */}
        {/* </div> */}
        <div className="realisations-carousel">
          <Carousel1 />
        </div>
        <div className="realisation-promesse">
          <div className="realisation-promesse-text">
            <h2>Ma promesse : un travail soigné & à votre écoute</h2>
            <p>
              <ul>
                <li>
                  Protection complète des surfaces et{" "}
                  <strong>finitions nettes</strong>
                </li>
                <li>
                  <strong>Ponctualité & respect</strong> des délais
                </li>
                <li>
                  Les dates annoncées sont respectées,{" "}
                  <strong>sans mauvaise surprise.</strong>
                </li>
                <li>Devis clair et gratuit</li>
                <li>Artisan local à Vannes</li>
                <li>
                  Proximité, réactivité et <strong>suivi personnalisé</strong>.
                </li>
              </ul>
            </p>
            <p>
              Une méthode <strong>simple et efficace</strong> : <br /> Après un
              premier échange, je me déplace pour{" "}
              <strong>évaluer précisément votre projet</strong>. <br />
              Un <strong>devis détaillé</strong> vous est ensuite proposé.{" "}
              <br />
              Les travaux sont réalisés dans le respect de votre logement, avec
              <strong> un suivi du début à la fin.</strong>
            </p>
          </div>
          <div className="realisation-promesse-image">
            <img src={PromesseImg} alt="Ma promesse" />
          </div>
        </div>
        {/* <div className="realisations-images-container-2"> */}
        {/* <div className="realisations-images">
          <div className="real1">
            <div className="real1img">
              <p className="real3cat">Catégorie</p>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
              dolorum a ad eius quibusdam maiores, perferendis illo quos hic
              doloremque dicta tempore adipisci nam cumque molestiae eaque
              reprehenderit? Iure delectus perspiciatis consequatur animi
              adipisci.
            </p>
          </div>
          <div className="real2">
            <div className="real2img">
              <p className="real4cat">Catégorie</p>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
              dolorum a ad eius quibusdam maiores, perferendis illo quos hic
              doloremque dicta tempore adipisci nam cumque molestiae eaque
              reprehenderit? Iure delectus perspiciatis consequatur animi
              adipisci.
            </p>
          </div>
        </div> */}
        {/* </div> */}
        {/* <div className="realisations-images-container-3"> */}
        {/* <div className="realisations-images">
          <div className="real1">
            <div className="real1img">
              <p className="real5cat">Catégorie</p>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
              dolorum a ad eius quibusdam maiores, perferendis illo quos hic
              doloremque dicta tempore adipisci nam cumque molestiae eaque
              reprehenderit? Iure delectus perspiciatis consequatur animi
              adipisci.
            </p>
          </div>
          <div className="real2">
            <div className="real2img">
              <p className="real6cat">Catégorie</p>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet
              dolorum a ad eius quibusdam maiores, perferendis illo quos hic
              doloremque dicta tempore adipisci nam cumque molestiae eaque
              reprehenderit? Iure delectus perspiciatis consequatur animi
              adipisci.
            </p>
          </div>
        </div> */}
        {/* </div> */}
      </div>
      <Footer />
    </div>
  );
};

export default Realisations;
